export class HasHistoricalClaimsConfig {
  public enabled: boolean;

  constructor(config: boolean) {
    config === true || config === undefined || config === null
      ? (this.enabled = true)
      : (this.enabled = false);
  }
}
